<template>
  <v-card>
    <WifiDebugDialog ref="debugDialog" />
    <MailboxDetailsDialog ref="detailsDialog" />

    <ODialogBar no-close title="Status do Embarque">
      <v-btn icon @click="reload" class="ml-2">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn icon title="Preview" @click="preview">
        <v-icon>mdi-code-braces</v-icon>
      </v-btn>
    </ODialogBar>
    <OLoadingLine absolute :value="isLoading" />

    <v-card-text class="pa-4 d-flex flex-column gap-6">
      <OCapCont label="Última alteração">
        <span v-if="lastUpdate == null">─</span>
        <span v-else>
          {{ lastUpdate.updatedAt | moment }}
          por {{ lastUpdate.updatedBy }}
        </span>
      </OCapCont>

      <OCapCont label="Último mailbox criado">
        <span v-if="created == null">─</span>
        <span v-else>
          {{ created.createdAt | moment }}
          (id
          <a
            style="text-decoration: underline"
            @click="showMailboxDetails(created.id)"
            >{{ created.id }}</a
          >)
        </span>
      </OCapCont>

      <OCapCont label="Último mailbox entregue">
        <span v-if="delivered == null">─</span>
        <span v-else>
          {{ delivered.deliveredAt | moment }}
          (id
          <a
            style="text-decoration: underline"
            @click="showMailboxDetails(delivered.id)"
            >{{ delivered.id }}</a
          >)
        </span>
      </OCapCont>

      <OAlert error v-if="errMessage != null">
        Houve um erro ao recuperar as redes wifi deste módulo:
        {{ errMessage }}
      </OAlert>

      <OAlert
        warning
        v-if="status == 'outdated'"
        message="Mailbox defasado, clique no botão abaixo para criar um novo."
      />

      <OAlert
        ok
        v-if="status == 'ok-waiting'"
        message="Mailbox criado, aguardando entrega"
      />

      <OAlert
        ok2
        v-if="status == 'ok-delivered'"
        message="Mailbox criado e entregue"
      />

      <div class="text-center">
        <v-btn
          class="w-300"
          @click="createMailbox"
          :disabled="vehicle.clientId == null"
        >
          Criar Mailbox de WifiConfig
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import WifiDebugDialog from './WifiDebugDialog.vue'
import { WifiAssoc, MailboxItem } from '../../../models/index.js'
import MailboxDetailsDialog from '../../clients/home/mailbox/DetailsDialog.vue'
import moment from 'moment'

export default {
  components: { WifiDebugDialog, MailboxDetailsDialog },
  props: {
    vehicle: { required: true }
  },
  data() {
    return {
      isLoading: false,
      errMessage: null,
      lastUpdate: null,
      created: null,
      delivered: null
    }
  },
  mounted() {
    this.reload()
  },
  watch: {
    vehicle() {
      this.reload()
    }
  },
  computed: {
    status() {
      let U = this.lastUpdate && this.lastUpdate.updatedAt
      let C = this.created && this.created.createdAt

      if (U == null) return null
      if (C == null || moment(C).isBefore(U)) {
        return 'outdated'
      }

      if (this.created.deliveredAt == null) {
        return 'ok-waiting'
      }

      return 'ok-delivered'
    }
  },
  methods: {
    reload() {
      this.$loadingQuiet(() => this.fetchData())
    },
    async fetchData() {
      let assocs = await WifiAssoc.findByVehicle(this.vehicle.id)
      this.lastUpdate = assocs.reduce((acc, assoc) => {
        if (acc == null || moment(assoc.updatedAt).isAfter(acc.updatedAt)) {
          return assoc
        } else {
          return acc
        }
      }, null)

      let { created, delivered } = await MailboxItem.findLatestPair(
        this.vehicle.clientId,
        'wifiConfig'
      )

      this.created = created
      this.delivered = delivered
    },
    preview() {
      this.$refs.debugDialog.open(this.vehicle.id)
    },
    showMailboxDetails(mbId) {
      this.$refs.detailsDialog.open(mbId)
    },
    async createMailbox() {
      this.$rootLoading(async () => {
        let vehicle = this.vehicle
        let res = await WifiAssoc.findByVehicle(this.vehicle.id)
        let networkIds = res.map((x) => x.networkId)

        let label = `Veículo #${vehicle.id} ${vehicle.code}`
        let clientId = vehicle.clientId
        let mailbox = await WifiAssoc.previewMailbox({
          networkIds,
          label,
          clientId
        })

        if (mailbox.hasError) {
          this.$snack('O mailbox de configs possui erros!', { color: 'red' })
          return
        }

        await MailboxItem.save(mailbox)

        this.$snack('Mailbox criado com sucesso')
        this.reload()
      })
    }
  }
}
</script>

<style></style>
